import { FieldActionOnValuesFunction } from '../types';
import { DeclareAndSubmitApplicationModel } from '../../api/models';
import { getTitleOptions } from './rndDeclaration';

export const pdfDeclarationAndSubmission: FieldActionOnValuesFunction<DeclareAndSubmitApplicationModel> = {
    title: getTitleOptions,
};
